import React from 'react'
import ImpactOfMultiOmicsCarousel from './ImpactOfMultiOmicsCarousel'

function ImpactOfMultiOmics() {
  return (
    <div className='impactofmultiOmics-bg pt-3'>
      <div className='p-5'>
      <div className='fw-bold fs-1 missionandvisiontextcolor impactofmultiOmics-main-text'>
            Unlocking the Code of Life: The Impact of Multi-Omics
            </div>
        <div className=' p-3 row w-100 impactofmultiOmics-devision-main'>
          <div className='impactofmultiOmics-left-content col-md-5'>
          

            <div className='fs-5 mt-5'>
            Multi-omics is an integrative approach that combines different 
            layers of biological information such as genomics (genes), 
            proteomics (proteins), metabolomics (metabolites), transcriptomics (gene activity), 
            the oral and gut microbiomes (microbial communities), 
            and lipidomics (fats and lipids) to create a comprehensive picture of the body’s function.
            </div>

            <div className='fs-5 mt-5' >
            Each field provides unique insights into health, 
             when combined, they offer a powerful tool for understanding 
            complex health conditions uncovering disease mechanisms and tailoring precise treatments. 
            </div>
          </div>
            
          <div className='impactofmultiOmics-right-content col-md-7'>
                <ImpactOfMultiOmicsCarousel/>
            </div>
        </div>
      </div>
      
        
    </div>
  )
}

export default ImpactOfMultiOmics